<!--  -->
<template>
  <div>
    <!-- <div style="margin-bottom:10px">
      <el-input v-model="pageIfon.name" style="width:200px;margin-right:10px" placeholder="请输入姓名" />
      <el-button type="primary" @click="search">搜索</el-button>
      <el-button type="primary" @click="reset">重置</el-button>
    </div> -->

    <el-table
      ref="multipleTable"
      :data="tableData"
      style="width: 100%"
    >
      <!-- @selection-change="handleSelectionChange" -->
      <!-- <el-table-column
        type="selection"
        width="55"
        align="center"
        :selectable="selectable"
      /> -->
      <el-table-column
        prop="key"
        label="ID"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.key }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="value"
        label="版本号"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.value }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="pullclick(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    /> -->
  </div>
</template>

<script>
import { getUpPlusWwVersion, setUpPlusWwVersion } from '@/api/templatelist.js'
// import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    // PaginationRight
  },
  data() {
    return {
      pageIfon: {
        page: 1,
        pageSize: 10,
        name: null
      },
      tableData: [],
      multipleSelection: [],
      total: null,
      items: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(item) {
      console.log('收到item', item)
      this.items = item
      this.candlist()
    },
    async candlist() {
      const data = await getUpPlusWwVersion({ ...this.pageIfon })
      this.tableData = data.data
      // this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.candlist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.candlist()
    },
    handleSelectionChange(val) {
      const allselect = val.map(re => re.openId)
      this.multipleSelection = allselect
    },
    selectable(row, index) {
      // eslint-disable-next-line eqeqeq
      return row.canChose != 0 // 通过某个值来进行判断，规定那一行的选择框被禁用
    },
    pullclick(item) {
      setUpPlusWwVersion({
        employee_no: this.items.employee_no,
        login_version: item.key
      }).then((res) => {
        this.$message({
          type: 'success',
          message: '设置成功'
        })
        this.$emit('vasionupdata')
      })
    },
    search() {
      this.pageIfon.page = 1
      this.candlist()
    },
    reset() {
      this.pageIfon.page = 1
      this.pageIfon.pageSize = 10
      this.pageIfon.name = null
      this.candlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.avatar_box{
  width: 50px;
  height: 50px;
}
.pull_box{
  text-align: right;
}
</style>
